import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook que registra atalhos de teclado globais do app.
 * Atalhos não disparam quando o foco está em inputs/textareas/selects.
 */
export const useKeyboardShortcuts = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isTyping = () => {
      const tag = document.activeElement?.tagName;
      const isEditable = document.activeElement?.isContentEditable;
      return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || isEditable;
    };

    const handler = (e) => {
      // Ctrl+K → focar na busca do header
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        document.getElementById('header-search')?.focus();
        return;
      }

      // Atalhos sem modificadores (só fora de inputs)
      if (isTyping()) return;

      // N → Nova transação
      if (e.key === 'n' || e.key === 'N') {
        window.dispatchEvent(new CustomEvent('shortcut:newTransaction'));
        return;
      }

      // ? → Mostrar atalhos
      if (e.key === '?') {
        window.dispatchEvent(new CustomEvent('shortcut:showHelp'));
        return;
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate]);
};

export default useKeyboardShortcuts;
